import { useGetList } from 'ra-core'

export type SpecialistRecord = { id: string | number; first_name?: string; last_name?: string; email?: string }

/** Mirrors `apps/products/ProductOptionsSection.tsx`'s own separate `specialistLabel` (that one stays per-app, HATCH-134's `useCurrentAdminUser.ts` precedent) — moved here from `apps/orders` (HATCH-154) once `apps/specialists-calendar`/`apps/doctor-profiles`' "Calendar" tab needed the same `RescheduleBookSlotDialog` this label feeds. */
export function specialistLabel(specialist: SpecialistRecord): string {
  const name = [specialist.first_name, specialist.last_name].filter(Boolean).join(' ')
  return specialist.email ? `${name} (${specialist.email})` : name
}

/**
 * Resolves an `owner_id` to its specialist's display name (review feedback:
 * "lets make Specialist column - reference - (it is owner_id column right?)
 * -> reference to doctors list"). `OrderEventsSection.tsx`/`OrderItemsSection.tsx`
 * aren't `ResourceTable`-backed (their rows come from a bespoke per-order
 * fetch, not a `dataProvider` resource list), so they can't use
 * `ReferenceFieldConfig` — this fetches the same already-registered
 * `specialists` resource (`fetchAllForGetMany`, unpaginated `GET
 * users/doctors`) directly and returns a lookup function instead. `specialists`
 * has no registered `<Resource>` routes, so — same as `ReferenceFieldConfig`
 * itself would in this situation — this only resolves the display name, it
 * never renders a link.
 */
export function useSpecialistLookup(): (id: string | number | null | undefined) => string {
  const { data } = useGetList<SpecialistRecord>('specialists', {
    pagination: { page: 1, perPage: 100 },
    sort: { field: 'first_name', order: 'ASC' },
    filter: {},
  })
  return (id) => {
    if (!id) return '—'
    const specialist = (data ?? []).find((item) => String(item.id) === String(id))
    return specialist ? specialistLabel(specialist) : String(id)
  }
}
